import React from 'react';

// @ts-ignore
import Icon from 'assets/images/traps/STR.svg';

interface IconProps {
  height?: number;
  width?: number;
}

const SnapTrapRatIcon: React.FC<IconProps> = ({ height = 30, width = 30 }) => {
  return <img src={Icon} height={height} width={width} alt="Rat Icon" />;
};

export default SnapTrapRatIcon;
